// --------------------------------------- Project List
export const ProjectList = [{
  img: "/iss.png",
  title: "NGO Indraprastha Sewa Samiti",
  description:
    "An NGO registered under Society Registeration Act 1860 working for welfare of the public.",
  tech_stack: ["HTML", "CSS", , "ReactJs", "NodeJs", "MongoDB"],
  github_url: "https://github.com/anshjindal/indraprastha-frontend",
  demo_url: "https://www.indraprasthasewa.in/",
},
  {
    img: "/studybuddythumbnail.png",
    title: "Study Buddy App",
    description:
      "An app to help International Students in Canada to navigate their challenging journey.",
    tech_stack: ["HTML", "CSS", , "ReactJs", "NodeJs", "MongoDB", "Axios"],
    github_url: "https://github.com/anshjindal/studentbuddy",
    demo_url: "https://studentbuddyapp.vercel.app/",
  },
  {
    img: "/project9.png",
    title: "Project 9",
    description:
      "Northeastern University College of Professional Studies's flagship research project website lead by Faculties of Boston and UK Campuses",
    tech_stack: ["HTML", "CSS", "Wordpress", "Project Management"],
    github_url: "",
    demo_url: "https://project9.sites.northeastern.edu",
  },
  {
    img: "/aj-social.png",
    title: "AJ-Social",
    description:
      "A social media app",
    tech_stack: ["HTML", "CSS", "Javascript", "React"],
    github_url: "https://github.com/anshjindal/social-media-app/",
    demo_url: "https://aj-social.vercel.app",
  },
];

// --------------------------------------- Skills

export const stackList = [
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg",
    name: "HTML",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg",
    name: "CSS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg",
    name: "JavaScript",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg",
    name: "ReactJS",
  },
  /*{
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nextjs/nextjs-original.svg",
    name: "NextJs",
  },*/
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
    name: "Typescript",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/git/git-original.svg",
    name: "Git",
  },
  /*{
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg",
    name: "React Native",
  },*/
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original.svg",
    name: "NodeJS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/firebase/firebase-plain.svg",
    name: "Firebase",
  },
  /*{
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original.svg",
    name: "MongoDB",
  },*/
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
    name: "Python",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/flask/flask-original.svg",
    name: "Flask",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/c/c-original.svg",
    name: "C",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original.svg",
    name: "MySQL",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-original.svg",
    name: "Bootstrap",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/materialui/materialui-original.svg",
    name: "Material UI",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/figma/figma-original.svg",
    name: "Figma",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/tailwindcss/tailwindcss-plain.svg",
    name: "TailwindCSS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/vscode/vscode-original.svg",
    name: "VS Code",
  },
];
